export const payments = (state = [], action) => {
  switch (action.type) {
    case 'SET_PAYMENTS':
      return action.data;
    default:
      return state;
  }
};

const defaultClientDataState = {
  cvc: '',
  expiryDate: '',
  expiryMonth: 1,
  expiryYear: new Date().getFullYear(),
  passport: '',
  cardNumber: '',
  phone: ''
};

export const clientPaymentData = (state = defaultClientDataState, action) => {
  switch (action.type) {
    case 'SET_CLIENT_PAYMENT_DATA':
      return action.data;
    default:
      return state;
  }
};

export const clientTips = (state = null, action) => {
  switch (action.type) {
    case 'SET_CLIENT_TIPS':
      return action.data;
    default:
      return state;
  }
};

export const clientPaymentAmount = (state = 0, action) => {
  switch (action.type) {
    case 'SET_PAYMENT_AMOUNT':
      return action.data;
    default:
      return state;
  }
};

export const clientTipType = (state = null, action) => {
  switch (action.type) {
    case 'SET_CLIENT_TIP_TYPE':
      return action.data;
    default:
      return state;
  }
};

